import { CATEGORY_CONFIG, type Category } from '@dd/shared';

export const BRAND = '#D12B29';
export const categoryColor = (c: Category): string => CATEGORY_CONFIG[c].color;

/** Light tint for a category-coloured badge background (hex → rgba 12%). */
export function tint(hex: string, alpha = 0.12): string {
  const h = hex.replace('#', '');
  const n = parseInt(h.length === 3 ? h.split('').map((x) => x + x).join('') : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

/** Point the whole UI at the shop's category colour: every `bg-cat-soft`, `text-cat-deep`, `border-cat` follows (see theme.css). */
export function applyCategoryTheme(category: Category | null | undefined): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (!category) { root.style.removeProperty('--cat'); delete root.dataset.category; return; }
  root.style.setProperty('--cat', CATEGORY_CONFIG[category].color);
  root.dataset.category = category;
}
